<template>
    <section v-if="galleryData.length > 0" class="py-12 px-5 md:px-3 xl:px-0">
        <div class="container">
            <h2
                class="font-heading uppercase text-2xl md:text-3xl lg:text-4xl mb-5 text-center text-teal"
                v-text="snippets.vacany_single_snippets_slider_title"
            ></h2>
            <swiper
                :slides-per-view="1"
                :centered-slides="true"
                :navigation="{
                    prevEl: '.slider-prev',
                    nextEl: '.slider-next',
                }"
                :breakpoints="{
                    '640': {
                        slidesPerView: 3,
                    },
                    '768': {
                        slidesPerView: 4,
                    },
                    '1024': {
                        slidesPerView: 5,
                    },
                }"
                :loop="true"
                class="mySwiper"
                data-slide-name="VACANCY_SLIDER"
                @swiper="trackSwiperEvents"
            >
                <swiper-slide v-for="(item, itemIndex) in galleryData" v-slot="{ isActive }" :key="itemIndex">
                    <div
                        class="bg-white px-3 py-3 md:aspect-square flex-shrink-0 h-full border border-gray-300 shadow-topanimation w-full"
                        :class="isActive ? 'scale-100' : 'scale-90'"
                    >
                        <div class="w-full h-full overflow-hidden flex-shrink-0">
                            <img
                                class="w-full h-full object-cover aspect-square"
                                :src="item.permalink"
                                :alt="item.alt"
                            />
                        </div>
                    </div>
                </swiper-slide>
                <div class="flex justify-center pt-5 space-x-3">
                    <button class="slider-prev p-3 hover:text-orange">
                        <i class="fa-regular fa-long-arrow-left text-2xl"></i>
                    </button>
                    <button class="slider-next p-3 hover:text-orange">
                        <i class="fa-regular fa-long-arrow-right text-2xl"></i>
                    </button>
                </div>
            </swiper>
        </div>
    </section>
</template>
<script setup>
import { Swiper, SwiperSlide } from "swiper/vue";
import SwiperCore, { Navigation } from "swiper";
import { inject } from "vue";
import { trackSwiperEvents } from "@/analyticsHelper";

const snippets = inject("statamic_snippets");

SwiperCore.use([Navigation]);

const props = defineProps({
    galleryData: {
        type: Object,
        required: true,
    },
});
</script>
